<p class="debugMessage"><small>Accounts-List:</small></p>

<div class="main-accounts-div">

	<ng-template #RouterOutlet>
		<router-outlet #outlet="outlet"></router-outlet>
	</ng-template>

	<ng-container *ngIf="currentUser && currentUser.AdminSite; then UseSplitter else OutletOnly"> </ng-container>

	<ng-template #OutletOnly>
		<ng-container *ngTemplateOutlet="RouterOutlet"></ng-container>
	</ng-template>

	<ng-template #UseSplitter>
		<nav class="navbar navbar-expand-lg bg-body-tertiary" *ngIf="currentUser && displayedAccounts">
			<span style="font-weight: bold;">My Accounts</span>
			<span class="me-auto"></span>
			<app-filter-box (search)="applyFilter($event)" Caption="Filter Accounts:"
				PlaceHolder="Filter Accounts List" />
			<span mat-icon-button class="app-icon app-icon--add" *ngIf="currentUser.AdminSite" (click)="AddAccount()"
				style="margin-right: var(--default-margin);"><mat-icon /></span>
		</nav>
		<ejs-splitter #horizontal height="calc(100vh - 150px)" separatorSize=4 width='100%'>
			<e-panes>
				<e-pane size='30%' min='5%'>
					<ng-template #content>
						<div class="accountTable" *ngIf="myAccounts">
							<div class="accountListMobile">
								<div style="overflow-y: auto;">
									<div class="accountGrid gridRow"
										*ngFor="let account of displayedAccounts.filteredData"
										style="padding-left: 0.2em; padding-right: 0.1em;"
										(click)="SelectAccount(account.GUID)">
										<span class="gridHeadingName">Name:</span>
										<span class="gridName">
											{{account.Name}}
											<!-- #35 Add an Account Expiry Warning and Trial warning -->
											<app-account-expiry [selectedAccount]="account" [pill]="true" />
										</span>
										<span class="gridHeadingDescription">Description:</span>
										<span class="gridDescription">{{account.Description}}</span>
										<span class="gridHeadingOwner">Owner:</span>
										<span class="gridOwner">{{account.Owner}}</span>
										<span class="gridImage">
											<img src="{{imagePathAccounts()}}{{account.ID}}?{{account.Modified}}"
												style="max-height: 50px;padding: 5px;max-width: 50px;"
												onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
												[attr.x-contenttype]="'image/png'"
												(click)="viewImage(imagePathAccounts() + account.ID + '?' + account.Modified)" />
										</span>
										<span *ngIf="account.Admin" class="app-icon app-icon--edit gridHover gridMenu">
											<mat-icon style="color: black;" (click)="editAccount(account)" />
										</span>
									</div>
								</div>
							</div>
						</div>
					</ng-template>
				</e-pane>
				<e-pane>
					<ng-template #content>
						<div style="padding: 1em;">
							<ng-container *ngTemplateOutlet="RouterOutlet"></ng-container>
						</div>
					</ng-template>
				</e-pane>
			</e-panes>
		</ejs-splitter>
	</ng-template>
</div>